/**
 * AngularJS digest helpers.
 *
 * These exist because Sentry and OpenReplay instrumentation can intercept
 * `$timeout`, `$apply`, and `$evalAsync` in ways that prevent a digest from
 * firing for scope changes made from outside Angular's zone (e.g. Service
 * Worker postMessage callbacks). A raw `setTimeout` → `$scope.$apply()`
 * guarantees a digest bypasses those wrappers.
 */

/**
 * Schedule a digest cycle on the given scope via a raw setTimeout. Safe to
 * call from contexts where a digest may or may not already be running —
 * "$digest already in progress" errors are swallowed silently as they are
 * expected. Other errors are logged so real problems aren't hidden.
 */
export function forceDigest($scope: angular.IScope, delayMs: number = 50): void {
    setTimeout(() => {
        try {
            $scope.$apply();
        } catch (e: any) {
            if (e && e.message && !e.message.includes('$digest') && !e.message.includes('$apply')) {
                console.error('forceDigest: unexpected error:', e);
            }
        }
    }, delayMs);
}
